/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StartInvitationRequest } from '../models/StartInvitationRequest';
import type { SubmitInvitationRequest } from '../models/SubmitInvitationRequest';
import type { user_portal_api__controllers__authenticator_enrollment_invitation_controller__ChooseAuthenticatorRequest } from '../models/user_portal_api__controllers__authenticator_enrollment_invitation_controller__ChooseAuthenticatorRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticatorEnrollmentInvitationService {
    /**
     * Validate the magic token, start the flow, and set the session cookie.
     * Validate the magic token, start the flow, and set the session cookie.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startInvitationFlow(
        requestBody: StartInvitationRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment-invitation/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit
     * @param requestBody
     * @param enrollmentInvitationSession
     * @returns any Successful Response
     * @throws ApiError
     */
    public static submit(
        requestBody: SubmitInvitationRequest,
        enrollmentInvitationSession?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment-invitation/submit',
            cookies: {
                'enrollment_invitation_session': enrollmentInvitationSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Enrollment Invitation Alternatives
     * @param enrollmentInvitationSession
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getEnrollmentInvitationAlternatives(
        enrollmentInvitationSession?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/enrollment-invitation/authenticator-alternatives',
            cookies: {
                'enrollment_invitation_session': enrollmentInvitationSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Choose Enrollment Invitation Authenticator
     * @param requestBody
     * @param enrollmentInvitationSession
     * @returns any Successful Response
     * @throws ApiError
     */
    public static chooseEnrollmentInvitationAuthenticator(
        requestBody: user_portal_api__controllers__authenticator_enrollment_invitation_controller__ChooseAuthenticatorRequest,
        enrollmentInvitationSession?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment-invitation/choose-authenticator',
            cookies: {
                'enrollment_invitation_session': enrollmentInvitationSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Finalize the flow and clear the session cookie. No token exchange.
     * Finalize the flow and clear the session cookie. No token exchange.
     * @param enrollmentInvitationSession
     * @returns any Successful Response
     * @throws ApiError
     */
    public static complete(
        enrollmentInvitationSession?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enrollment-invitation/complete',
            cookies: {
                'enrollment_invitation_session': enrollmentInvitationSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
